import { makeAutoObservable } from "mobx";

interface ModalInterface {
  title?: string;
  description?: string;
  body?: JSX.Element;
  size?: "S" | "M";
  isLoading?: boolean;
  closeOnClickOutside?: boolean;
  onClose: () => void;
}

const defaultModal: ModalInterface = {
  title: undefined,
  description: undefined,
  size: "S",
  isLoading: false,
  closeOnClickOutside: true,
  onClose: () => {},
};

export class ErrorModalStore {
  constructor() {
    makeAutoObservable(this);
  }

  open: boolean = false;
  modal: ModalInterface = defaultModal;

  openModal({
    title,
    description,
    body,
    size,
    onClose,
    isLoading,
    closeOnClickOutside,
  }: ModalInterface): void {
    this.modal = {
      title,
      description,
      body,
      size,
      onClose,
      isLoading,
      closeOnClickOutside,
    };
    this.open = true;
  }

  closeModal(): void {
    this.open = false;
    this.modal = defaultModal;
  }
}
